var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import { checkableTagDefaultProps } from './defaults';
import { SpanTag } from '../../Utils/AtomicTag';
var CheckableTag = /** @class */ (function (_super) {
    __extends(CheckableTag, _super);
    function CheckableTag(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            checked: props.checked,
        };
        return _this;
    }
    CheckableTag.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.checked !== prevProps.checked) {
            this.state = {
                checked: this.props.checked,
            };
        }
    };
    CheckableTag.prototype.toggle = function (checked) {
        this.setState({
            checked: checked,
        });
        this.props.onChange();
    };
    CheckableTag.prototype.render = function () {
        var _this = this;
        var baseClassName = [
            'border',
            'border-solid',
            'px-2',
            'h-6',
            'leading-6',
            'cursor-pointer',
            'rounded',
            'text-sm',
        ];
        var checkedClassName = __spread(baseClassName, [
            'border-brand-600',
            'bg-brand-600',
            'text-white',
        ]);
        var unCheckedClassName = __spread(baseClassName, ['text-black', 'border-0']);
        return (React.createElement(SpanTag, { atomics: this.state.checked ? checkedClassName : unCheckedClassName, onClick: function (e) { return _this.toggle(!_this.state.checked); }, className: this.props.className, autoPrefixedClassName: "checkable-tag", style: this.props.style }, this.props.children));
    };
    CheckableTag.defaultProps = checkableTagDefaultProps;
    return CheckableTag;
}(React.Component));
export { CheckableTag };
